import vue from 'vue'
import Tips from './Tips.vue'

// 生成一个扩展实例构造器
const TipsConstructor = vue.extend(Tips)

// 定义弹出组件的函数 接收三个参数 消息 回调 是否显示取消按钮
function showPermissionTips(message, fun, btnEsc, okText,labor) {
  // 实例化一个 Tips.vue
  const _toast = new TipsConstructor({
    data() {
      return {
        show: true,
        message,
        btnEsc,
        fun,
        okText,
        labor
      }
    }
  })

  // 把实例化的 FollowToast.vue 添加到 body 里
  let element = _toast.$mount().$el
  document.body.appendChild(element)
}

// 需要在main.js 里面使用 Vue.use(showPermissionTips);
showPermissionTips.install = (Vue) => {
  // 将组件注册到 vue 的 原型链里去
  Vue.prototype.$message.showPermissionTips = (message, fun, btnEsc = false, okText = '知道了',labor=false) => {
    showPermissionTips(message, fun, btnEsc, okText,labor)
  }
}

// 导出
export default showPermissionTips
